export var VaultInviteServiceEvent;
(function (VaultInviteServiceEvent) {
    VaultInviteServiceEvent["InviteSent"] = "VaultInviteServiceEvent.InviteSent";
    VaultInviteServiceEvent["InvitesReloaded"] = "VaultInviteServiceEvent.InvitesReloaded";
})(VaultInviteServiceEvent || (VaultInviteServiceEvent = {}));
